import { EventEmitter } from '@angular/core'
import { AbstractControl, FormBuilder, FormControl, FormGroup } from '@angular/forms'
import { filter } from 'rxjs/operators'
import { isSomething } from '@tokeet/tv3-platform'

export interface IDataDictionaryDialogService {
  open(branding?: boolean)
}

export abstract class EmailTemplateAbstractComponent {
  form: FormGroup
  valid = new EventEmitter<boolean>()
  reset = new EventEmitter<boolean>()
  tinyMceEditor: any

  plainTextCtrl = new FormControl()

  isPlain = false

  constructor(protected fb: FormBuilder, protected dataDictionaryDialogService: IDataDictionaryDialogService) {}

  onDataDictionary() {
    this.dataDictionaryDialogService
      .open(true)
      .pipe(filter((tag) => isSomething(tag)))
      .subscribe((tag) => {
        if (this.isPlain) {
          const plainTextValue = this.plainTextCtrl.value
          this.plainTextCtrl.patchValue(plainTextValue + tag)
        } else {
          try {
            this.tinyMceEditor['editor'].execCommand('mceInsertContent', false, tag)
          } catch (e) {}
        }
      })
  }

  onSubjectDataDictionary(control: AbstractControl) {
    this.dataDictionaryDialogService
      .open()
      .pipe(filter((tag) => isSomething(tag)))
      .subscribe((tag) => {
        const value = `${control.value} ${tag}`
        control.setValue(value)
      })
  }

  onToggleInputType() {
    this.isPlain = !this.isPlain
  }
}
